(function () {
  const steps = Array.from(document.querySelectorAll('.step'));
  const progress = document.querySelector('.progress');
  const barFill = document.querySelector('.progress .fill');

  const state = {
    stepIndex: 0,                   // 0 start, 1 purpose, 2 budget
    answers: { purpose: null, budget: null },
  };

  const showStep = (i) => {
    state.stepIndex = i;
    steps.forEach((s, idx) => {
      s.classList.toggle('is-active', idx === i);
      s.hidden = idx !== i;
    });

    if (i === 0) {
      progress.style.display = 'none';
    } else {
      progress.style.display = 'block';
      barFill.style.width = `${(i / 2) * 100}%`;
    }
    syncButtons();
  };

  const syncButtons = () => {
    if (state.stepIndex === 1) {
      document.querySelector('[data-action="next"]').disabled = !state.answers.purpose;
    }
    if (state.stepIndex === 2) {
      document.querySelector('[data-action="finish"]').disabled = !state.answers.budget;
    }
  };

  // Start
  document.getElementById('btn-start').addEventListener('click', () => showStep(1));

  // Purpose select
  const grid = document.querySelector('.grid-choices');
  grid.addEventListener('click', (e) => {
    const el = e.target.closest('.choice');
    if (!el) return;
    grid.querySelectorAll('.choice').forEach(c => c.classList.remove('is-selected'));
    el.classList.add('is-selected');
    state.answers.purpose = el.dataset.value;
    syncButtons();
  });

  // Next from purpose
  document.querySelector('[data-action="next"]').addEventListener('click', () => {
    if (!state.answers.purpose) return;
    showStep(2);
  });

  // Back
  document.querySelectorAll('[data-action="back"]').forEach(b => {
    b.addEventListener('click', () => showStep(Math.max(0, state.stepIndex - 1)));
  });

  // budget radios
  const list = document.querySelector('.list-choices');
  list.addEventListener('change', (e) => {
    if (e.target.name !== 'budget') return;
    list.querySelectorAll('.row').forEach(r => r.classList.remove('is-selected'));
    e.target.closest('.row').classList.add('is-selected');
    state.answers.budget = e.target.value;
    syncButtons();
  });

  // Finish
  document.querySelector('[data-action="finish"]').addEventListener('click', () => {
    if (!state.answers.budget) return;
    let showClass = `${state.answers.purpose}-${state.answers.budget}`
    console.log("showClass:",showClass)
    //显示class位showClass的dom
    document.querySelector(`.${showClass}`).style.display = 'flex';
    document.querySelector(`.product-container`).style.display = 'block';
    
    //隐藏find-water-filter-box
    document.querySelector('.find-water-filter-box').style.display = 'none';
  });

  // init
  showStep(0);
})();
